import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import Select from 'antd/lib/select';
import Icon from 'antd/lib/icon';
import Button from 'antd/lib/button';
import { translate } from 'react-i18next';
import { Row, Col } from 'react-flexbox-grid';
import accountRules from '../../../../common/rules/accountRules';
import Checkbox from 'antd/lib/checkbox';

const formItemLayoutWithoutLabel = {
  wrapperCol: {
    xs: {
      span: 15,
      offset: 9,
    },
    sm: {
      span: 14,
      offset: 6
    },
  },
};

class AdditionalEmailsHelper extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    account: PropTypes.object.isRequired,
    isEditable: PropTypes.bool.isRequired,
    isCallCentrum: PropTypes.bool.isRequired,
    form: PropTypes.object.isRequired,
  };

  addEmail = () => {
    const { form } = this.props;
    const emailsKeys = form.getFieldValue('emailsKeys');
    const newEmails = [...emailsKeys, emailsKeys.length];
    form.setFieldsValue({ emailsKeys: newEmails });
    setTimeout(() => {
      form.setFieldsValue({ [`emails[${emailsKeys.length}].email`]: null });
      form.setFieldsValue({ [`emails[${emailsKeys.length}].prefered`]: false });
      form.setFieldsValue({ [`emails[${emailsKeys.length}].notContact`]: false });
      form.setFieldsValue({ [`emails[${emailsKeys.length}].anotherPerson`]: false });
      form.setFieldsValue({ [`emails[${emailsKeys.length}].undeliverable`]: false });
    });
  }

  removeEmail = key => {
    const { form } = this.props;
    const emailsKeys = form.getFieldValue('emailsKeys');
    const emails = form.getFieldValue('emails');
    emails.filter((_, i) => key !== i)
      .forEach((email, i) => {
        form.setFieldsValue({ [`emails[${i}].email`]: email.email });
        form.setFieldsValue({ [`emails[${i}].prefered`]: email.prefered });
        form.setFieldsValue({ [`emails[${i}].notContact`]: email.notContact });
        form.setFieldsValue({ [`emails[${i}].anotherPerson`]: email.anotherPerson });
        form.setFieldsValue({ [`emails[${i}].undeliverable`]: email.undeliverable });
    });
    form.setFieldsValue({
      emailsKeys: [...Array(emailsKeys.length - 1).keys()],
    });
  }

  render() {
    const { account, isEditable, isCallCentrum, form, t } = this.props;
    const { getFieldDecorator, getFieldValue } = form;

    // define helper for dynamic emails
    getFieldDecorator('emailsKeys', { initialValue: [...Array(account.emails.length).keys()] });

    return (
      <React.Fragment>
        { 
          getFieldValue('emailsKeys').map(key => (
            <Form.Item {...formItemLayoutWithoutLabel} key={key}>
              { !isEditable &&
                <div>
                  <Row>
                    <Col xs={12} sm={6} md={6} lg={6}>
                      <div style={{ wordBreak: 'break-all' }}>
                        <span>{account.emails[key] ? account.emails[key].email : null}</span>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} sm={4} md={6} lg={6}>
                      <Checkbox
                        style={{ display: 'inline-flex', alignItems: 'center' }}
                        checked={account.emails[key] ? account.emails[key].prefered : false}
                        disabled
                      >{t('Preferovaný')}
                      </Checkbox>                                      
                      <Checkbox
                        style={{ display: 'inline-flex', alignItems: 'center' }}
                        checked={account.emails[key] ? account.emails[key].notContact : false}
                        disabled
                      >{t('Nekontaktovať')}
                      </Checkbox>                                        
                      <Checkbox
                        style={{ display: 'inline-flex', alignItems: 'center' }}
                        checked={account.emails[key] ? account.emails[key].anotherPerson : false}
                        disabled
                      >{t('Iná osoba')}
                      </Checkbox>                    
                      <Checkbox
                        style={{ display: 'inline-flex', alignItems: 'center' }}
                        checked={account.emails[key] ? account.emails[key].undeliverable : false}
                        disabled
                      >{t('Nedoručiteľný')}
                      </Checkbox>
                    </Col>
                  </Row>
                </div>
              }
              { isEditable &&
              <div>
                  <Row>
                    <Col xs={12} sm={6} md={6} lg={6}>
                      {
                        getFieldDecorator(`emails[${key}].email`, {
                          rules: accountRules.email,
                          initialValue: account.emails[key] ? account.emails[key].email : null,
                        })(<Input size="default" placeholder={t('E-mail')} type="email" />)
                      }
                    </Col>
                    { (!isCallCentrum || account.emails.length <= key) &&
                        <Icon
                          className="dynamic-delete-button"
                          type="minus-circle-o"
                          title={t('Odstrániť email')}
                          onClick={() => this.removeEmail(key)}
                        />
                      }
                  </Row>
                  <Row>
                    {isEditable && getFieldDecorator(`emails[${key}].prefered`, {
                      initialValue: account.emails[key] ? account.emails[key].prefered : false,
                      valuePropName: 'checked',
                    })(<Checkbox style={{ marginRight: 10 }}>{t('Preferovaný')}</Checkbox>
                    )}
                    {isEditable && getFieldDecorator(`emails[${key}].notContact`, {
                      initialValue: account.emails[key] ? account.emails[key].notContact : false,
                      valuePropName: 'checked',
                    })(<Checkbox style={{ marginRight: 10 }}>{t('Nekontaktovať')}</Checkbox>
                    )}
                    {isEditable && getFieldDecorator(`emails[${key}].anotherPerson`, {
                      initialValue: account.emails[key] ? account.emails[key].anotherPerson : false,
                      valuePropName: 'checked',
                    })(<Checkbox style={{ marginRight: 10 }}>{t('Iná osoba')}</Checkbox>
                    )}
                    {isEditable && getFieldDecorator(`emails[${key}].undeliverable`, {
                      initialValue: account.emails[key] ? account.emails[key].undeliverable : false,
                      valuePropName: 'checked',
                    })(<Checkbox >{t('Nedoručiteľný')}</Checkbox>
                    )}                      
                  </Row>
                </div>
              }
            </Form.Item>
          ))
        }
        { isEditable && 
          <Form.Item {...formItemLayoutWithoutLabel}>
            <Row>
              <Col xs={6} sm={6} md={6} lg={6}>
                <Button type="dashed" size="small" onClick={this.addEmail} style={{ width: '100%' }}>
                  <Icon type="plus" /> {t('Pridať email')}
                </Button>
              </Col>
            </Row>
          </Form.Item>
        }
      </React.Fragment>
    );
  }
}

export default translate()(AdditionalEmailsHelper);



// WEBPACK FOOTER //
// ./src/features/account-management/components/profile/AdditionalEmailsHelper.js